export default {
  id: 14,
  title: 'Target #14 - Web Maker Logo',
  url: 'https://cssbattle.dev/play/14',
  colors: ['#F2F2B6', '#FF6D00', '#FD4602'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#f2f2b6}a{position:fixed;border:75px solid transparent}a[a],a[b]{top:85;border-top-width:130}a[c],a[d]{bottom:85;border-bottom-width:130}a[a]{border-top-color:#fd4602;left:80}a[b]{border-top-color:#ff6d00;left:60}a[c]{right:60;border-bottom-color:#ff6d00}a[d]{border-bottom-color:#fd4602;right:80}</style>',
}
